import { IconDotsVertical, IconLogout, IconUserCircle } from '@tabler/icons-react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';
import { useUserStore } from '@/stores/userStore';
import { useNavigate } from 'react-router-dom';

export function NavUser() {
  const { isMobile } = useSidebar();
  const { userInfo, clearUser } = useUserStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate('/login');
    setTimeout(() => {
      clearUser();
    }, 500);
  };

  const handleGoToAccountInfo = () => {
    navigate('/account-center/account-info');
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground gap-2.5 px-5"
            >
              <Avatar className="h-8 w-8 rounded-lg grayscale">
                <AvatarImage
                  src={userInfo?.avatarUrl}
                  alt={userInfo?.nickname || userInfo?.username || userInfo?.email}
                />
                <AvatarFallback className="rounded-lg">
                  {userInfo?.email?.slice(0, 2)?.toLocaleUpperCase()}
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight mr-4.5 group-data-[collapsible=compact]:hidden">
                <span className="truncate font-medium">
                  {userInfo?.nickname || userInfo?.username || userInfo?.email}
                </span>
                <span className="text-muted-foreground truncate text-xs">{userInfo?.email}</span>
              </div>
              <IconDotsVertical className="ml-auto size-4 group-data-[collapsible=compact]:hidden" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
            side={isMobile ? 'bottom' : 'right'}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <Avatar className="h-8 w-8 rounded-lg">
                  <AvatarImage
                    src={userInfo?.avatarUrl}
                    alt={userInfo?.nickname || userInfo?.username || userInfo?.email}
                  />
                  <AvatarFallback className="rounded-lg">
                    {userInfo?.email?.slice(0, 2)?.toLocaleUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium">
                    {userInfo?.nickname || userInfo?.username || userInfo?.email}
                  </span>
                  <span className="text-muted-foreground truncate text-xs">{userInfo?.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={handleGoToAccountInfo}>
                <IconUserCircle />
                个人信息
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout}>
              <IconLogout />
              退出账号
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
